import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { procurementApi, type PurchaseOrder } from '../../api/procurement';

export function PurchaseOrderPage() {
  const [pos, setPos] = useState<PurchaseOrder[]>([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void procurementApi.listPOs().then(setPos);
  }, []);

  async function createPO() {
    await procurementApi.createPO({
      vendor_id: 'vendor-a',
      items: [{ sku: 'SKU-001', quantity: 100, unit_price: 240 }],
    });
    setMsg('Purchase order created');
    setPos(await procurementApi.listPOs());
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/procurement" className="text-sm text-slate-600 hover:underline">← Procurement hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Purchase order manager</h1>
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <button type="button" onClick={() => void createPO()}
        className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">Create PO</button>
      <ul className="mt-6 space-y-2">
        {pos.map((po) => (
          <li key={po.id} className="rounded border p-3 text-sm">
            {po.po_number} — {po.vendor_id} · {po.status} · ₹{po.total_amount}
          </li>
        ))}
      </ul>
    </div>
  );
}
